import React, { useRef } from 'react';
import { BasicTextArea } from '../../assets/common';
import styled from 'styled-components';
import _ from 'lodash';
import { pdcMeetingApi } from '../../services/pdcMeetingApi';

const Container = styled.div`
  position: relative;
  width: 100%;
  color: #5d7083;
  font-size: 14px;

  span {
    position: absolute;
    right: 8px;
    top: 5px;
    font-size: 10px;
  }
`;

export const TextAreaWithCounter = ({ maxLength = 200, id, remarks, placeholder = '', ...props }) => {
  const spanRef = useRef();
  const currentLength = remarks ? remarks.length : 0;
  const handleInput = (e) => {
    const count = e.target.value.length;
    if (spanRef.current) {
      spanRef.current.textContent = `${count}/${maxLength}`;
    }
    debouncedAPICall(e.target.value);
  };

  const callAPI = async (remark) => {
    try {
      const response = await pdcMeetingApi.autoUpdateRemarks({ remark, id });
      const data = await response.json();
      console.log('API called:', data);
    } catch (error) {
      console.error('API error:', error);
    }
  };

  const debouncedAPICall = _.debounce(callAPI, 2000);

  return (
    <Container>
      <BasicTextArea
        resize="none"
        rows={4}
        maxLength={maxLength}
        padding="15px 10px"
        onInput={handleInput}
        defaultValue={remarks}
        placeholder={placeholder}
        {...props}
      />
      <span ref={spanRef}>
        {currentLength}/{maxLength}
      </span>
    </Container>
  );
};
